


           <div class="form-group product__option"  fxLayout="row" fxLayoutAlign="center center" >
            <div class="form-group" fxLayout="column" fxLayoutAlign="space-around center">
                <div class="m-6" style="font-size: large;">Select a Time Range</div>
<mat-form-field appearance="fill">
    <mat-label>Time From</mat-label>
    <input matTimepicker #t1="matTimepicker" #time1="ngModel" [minDate]="availableFrom" [maxDate]="selectedEnd"
      id="timepicker2" mode="24h" ngModel placeholder="Please select time..." name="time-1" (timeChange)="onSelectFrom($event)">
    <mat-icon matSuffix (click)="t1.showDialog()">access_time</mat-icon>
    <mat-error *ngIf="time1.touched && time1.invalid">Invalid Date</mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Time To</mat-label>
    <input matTimepicker #t2="matTimepicker" #time2="ngModel" [minDate]="selectedStart" [maxDate]="availableTo"
      id="timepicker3" mode="24h" ngModel placeholder="Please select time..." name="time-2" (timeChange)="onSelectTo($event)">
    <mat-icon matSuffix (click)="t2.showDialog()">access_time</mat-icon>
    <mat-error *ngIf="time2.touched && time2.invalid">Invalid Date</mat-error>
  </mat-form-field>

        </div>
